import { useState } from 'react';

const phones = [
  { name: 'Engin POLAT', number: '0507 607 4165', href: 'tel:+905076074165' },
  { name: 'Hamza POLAT', number: '0543 820 7155', href: 'tel:+905438207155' },
  { name: 'Hayrullah POLAT', number: '0543 641 2016', href: 'tel:+905436412016' },
];

export default function EmergencyBanner() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="relative bg-red-600 text-white w-full z-40">
      {/* Animated pulse indicator */}
      <div className="flex items-center justify-center flex-wrap gap-x-4 gap-y-1.5 px-4 py-2.5">
        {/* 7/24 badge */}
        <div className="flex items-center gap-1.5 shrink-0">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white"></span>
          </span>
          <span className="font-extrabold text-sm tracking-widest whitespace-nowrap" style={{ fontFamily: 'Poppins, sans-serif' }}>
            7/24 ACİL SERVİS
          </span>
          <span className="hidden sm:inline text-red-200 text-sm">—</span>
        </div>

        {/* Phone numbers */}
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
          {phones.map((p, i) => (
            <a
              key={p.name}
              href={p.href}
              className="flex items-center gap-1.5 font-bold text-sm hover:text-yellow-300 active:text-yellow-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-base"></i>
              <span className="hidden md:inline text-red-100 text-xs mr-0.5">{p.name}:</span>
              <span>{p.number}</span>
              {i < phones.length - 1 && (
                <span className="text-red-300 ml-1 hidden sm:inline">·</span>
              )}
            </a>
          ))}
        </div>
      </div>

      {/* Close button */}
      <button
        onClick={() => setVisible(false)}
        className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-white/70 hover:text-white cursor-pointer transition-colors rounded-full hover:bg-red-700"
        aria-label="Kapat"
      >
        <i className="ri-close-line text-base"></i>
      </button>
    </div>
  );
}
